<template>
  <focus-trap active tabindex="0">
    <div class="video-wrapper">
      <button
        @click="closeModal"
        v-html="buttonClose"
        v-if="showCloseButton"
        aria-label="Close modal"
        class="modal-close-button pure-button"
        tabindex="0"
      ></button>
      <div class="video-container">
        <video crossorigin="anonymous" playsinline ref="videomedia"></video>
      </div>
      <video-player-controls :video="video" :videoReference="this.$refs.videomedia" />
    </div>
  </focus-trap>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue';
import { mapState, mapMutations, mapGetters } from 'vuex';
import VideoPlayerControls from './VideoPlayerControls.vue';
import btnClose from 'assets/svg/btn-close.svg';

export default {
  components: {
    FocusTrap,
    VideoPlayerControls
  },
  computed: {
    ...mapState('application', {
      isMobile: state => state.device.device
    }),

    ...mapState('application', ['video']),

    ...mapGetters('application', ['usingExternalKeyboard'])
  },

  data() {
    return {
      buttonClose: btnClose,
      showCloseButton: true
    };
  },
  methods: {
    ...mapMutations('application', ['setModal']),

    closeModal() {
      this.setModal(undefined);
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  padding: 0px;
}
</style>
